import vue from "vue";
export const termConditionResponse = async (payload) => {
  const { id } = payload;
  return await vue.axios.get(
    `https://dev.app.fastforge.ai/cms/page/detail/${id}`
  );
};
export const privacySettingList = async (tenant) => {
  return await vue.axios.get(
    `https://dev.app.fastforge.ai/cms/privacy-setting/list?tenant=${tenant}`
  );
};
